import * as React from "react";
import { asThemeConsumer } from "../../../theme/Theme";
import { joinClasses } from "../../../utils/Filters";
var FormComp = function (props) {
    var clazzName = joinClasses(props.className || "", "scl-o-form");
    return !props.children
        ? null
        : (React.createElement("form", { className: clazzName, onSubmit: function (e) {
                e.preventDefault();
                if (props.isValid !== false && props.onSubmit) {
                    props.onSubmit();
                }
            } }, props.children));
};
/**
 *
 */
export var Form = asThemeConsumer(FormComp);
